import React, { useState, useEffect } from "react";
import { Loader, Pagination, Button } from "semantic-ui-react";
import { AssistanceApi } from "../../../../api";
import { AssistanceItem } from "../AssistanceItem";
import { useAuth } from "../../../../hooks";
import "./ListAssistance.scss";

const assistanceController = new AssistanceApi();
const EDUCA360_USER_ID = "67921ab3740e0f2aba258111";

export function ListAssistance(props) {
  const { reload, onReload } = props;
  const { accessToken, user } = useAuth();

  const [assistances, setAssistances] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [viewMode, setViewMode] = useState("all"); // "all" = Educa360, "mine" = propios

  useEffect(() => {
    (async () => {
      try {
        const response = await assistanceController.getAssistances(
          accessToken,
          page
        );
        let allAssistances = response.assistances.docs;

        if (viewMode === "all") {
          // Solo las asistencias creadas por Educa360
          allAssistances = allAssistances.filter(
            (item) => item.user === EDUCA360_USER_ID
          );
        } else {
          // Solo las tuyas
          const myId = user?.user?._id || user?._id;
          allAssistances = allAssistances.filter(
            (item) => item.user === myId
          );
        }

        setAssistances(allAssistances);
        setPagination({
          total: response.assistances.totalDocs,
          page: response.assistances.page,
          limit: response.assistances.limit,
          pages: response.assistances.totalPages,
        });
      } catch (error) {
        console.error("Error al cargar asistencias:", error);
      }
    })();
  }, [page, reload, accessToken, viewMode, user]);

  const changePage = (e, data) => setPage(data.activePage);
  const handleViewAll = () => {
    setViewMode("all");
    setPage(1);
  };
  const handleViewMine = () => {
    setViewMode("mine");
    setPage(1);
  };

  if (assistances === null) {
    return <Loader active inline="centered" />;
  }

  return (
    <div className="list-assistance">
      <div className="list-assistance__buttons">
        <Button
          onClick={handleViewAll}
          className="list-assistance__button"
          color={viewMode === "all" ? undefined : undefined}
        >
          ASISTENTES EDUCA360
        </Button>
        <Button
          onClick={handleViewMine}
          className="list-assistance__button"
          color={viewMode === "mine" ? undefined : undefined}
        >
          MIS ASISTENTES
        </Button>
      </div>

      {assistances.length === 0 ? (
        <h2>No hay Asistentes</h2>
      ) : (
        <div className="list-assistance__items">
          {assistances.map((assistance) => (
            <AssistanceItem
              key={assistance._id}
              assistance={assistance}
              onReload={onReload}
              // Solo permitimos editar si estamos en "mine"
              canEdit={viewMode === "mine"}
            />
          ))}
        </div>
      )}

      {pagination && (
        <div className="list-assistance__pagination">
          <Pagination
            activePage={pagination.page}
            totalPages={pagination.pages}
            ellipsisItem={null}
            firstItem={null}
            lastItem={null}
            onPageChange={changePage}
          />
        </div>
      )}
    </div>
  );
}
